import { TocItem } from "@gravity-ui/uikit";
import standardSlugify from "standard-slugify";

export const getKBTocItems = (markdown: string = ""): TocItem[] => {
  if (!markdown) return [];

  const lines = markdown.split("\n");
  const toc: TocItem[] = [];

  let currentH2: TocItem | null = null;

  for (const line of lines) {
    const h2 = line.match(/^##\s+(.*)/);
    const h3 = line.match(/^###\s+(.*)/);

    if (h2) {
      const title = h2[1].trim();
      const anchor = standardSlugify(title);

      const item = {
        value: anchor,
        href: `#${anchor}`,
        content: [title],
        items: [],
      };

      toc.push(item);
      currentH2 = item;
      continue;
    }

    if (h3 && currentH2 && currentH2.items) {
      const title = h3[1].trim();
      const anchor = standardSlugify(title);

      currentH2.items.push({
        value: anchor,
        href: `#${anchor}`,
        content: [title],
      });
    }
  }

  return toc;
};
